export default __webpack_public_path__ + "img/166e8e87ae0b6f3deed301a84e1af103.woff2";